import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var LoadEmpty = /*#__PURE__*/function (_Vue) {
  _inherits(LoadEmpty, _Vue);

  var _super = _createSuper(LoadEmpty);

  function LoadEmpty() {
    _classCallCheck(this, LoadEmpty);

    return _super.apply(this, arguments);
  }

  return LoadEmpty;
}(Vue);

LoadEmpty = __decorate([Component], LoadEmpty);
export default LoadEmpty;